import { jsx as _jsx } from "react/jsx-runtime";
// https://www.npmjs.com/package/rc-tooltip
import RCTooltip from 'rc-tooltip';
import clss from 'classnames';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Tooltip = function(_param) {
    var children = _param.children, className = _param.className, text = _param.text, hideArrow = _param.hideArrow, props = _objectWithoutProperties(_param, [
        "children",
        "className",
        "text",
        "hideArrow"
    ]);
    return(/*#__PURE__*/ _jsx("div", {
        className: className,
        onClick: function(e) {
            e.stopPropagation();
        },
        children: /*#__PURE__*/ _jsx(RCTooltip, _objectSpread({
            prefixCls: clss({
                'hide-arrow': hideArrow
            }, 'ex-tooltip')
        }, props, {
            children: /*#__PURE__*/ _jsx("span", {
                className: "relative text-inherit bg-inherit flex",
                style: {
                    fontSize: 'inherit'
                },
                children: children || text
            })
        }))
    }));
};
export default Tooltip;
